module.exports = __webpack_public_path__ + "img/centerIonc1.98d8179e.png";